import { Flex } from '@chakra-ui/react';
import React from 'react';

import { Button } from '@app/components/chakra/snippets/button';
import { CaseTypeMetadataEnum } from '@app/types/create-case';

import { useQueueSelfAssign } from '../hooks';

const QueueQuickAssign = ({
  setIsServiceQueueOpen,
}: {
  setIsServiceQueueOpen: (isServiceQueueOpen: boolean) => void;
}) => {
  const { handleSelfAssign } = useQueueSelfAssign({
    setIsServiceQueueOpen,
    caseTypeIds: [CaseTypeMetadataEnum.SERVICE],
  });

  return (
    <Flex padding="2">
      <Button
        onClick={handleSelfAssign}
        variant="outline"
        colorScheme="gray"
        width="full"
      >
        Quick assign next case
      </Button>
    </Flex>
  );
};

export default QueueQuickAssign;
